module.exports = __webpack_public_path__ + "static/img/ri-chat-3-line.b175da3a.svg";